import { render, staticRenderFns } from "./ListKontoTrans.vue?vue&type=template&id=87eddc54&scoped=true&"
import script from "./ListKontoTrans.vue?vue&type=script&lang=js&"
export * from "./ListKontoTrans.vue?vue&type=script&lang=js&"
import style0 from "./ListKontoTrans.vue?vue&type=style&index=0&id=87eddc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eddc54",
  null
  
)

component.options.__file = "ListKontoTrans.vue"
export default component.exports